export default __webpack_public_path__ + "static/media/dishdiary.62e4cdd5.webp";